// =============================================================================
// exportCsv — shared CSV download helper (T-295)
// One reusable export so every screen does it the same way. Excel-friendly
// (UTF-8 BOM), RFC-4180 quoting. Define columns as { header, value(row) }.
// =============================================================================

export type CsvColumn<T> = { header: string; value: (row: T) => unknown };

function cell(v: unknown): string {
  if (v === null || v === undefined) return "";
  const s = String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function exportCsv<T>(filename: string, rows: T[], columns: CsvColumn<T>[]): void {
  const header = columns.map((c) => cell(c.header)).join(",");
  const body = rows.map((r) => columns.map((c) => cell(c.value(r))).join(",")).join("\r\n");
  const csv = "﻿" + header + "\r\n" + body; // BOM so Excel reads UTF-8

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.toLowerCase().endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Convenience: stamp a filename with today's date (yyyy-mm-dd).
export function dated(name: string): string {
  return `${name}_${new Date().toISOString().slice(0, 10)}`;
}
